import {
  Badge,
  Button,
  ButtonProps,
  Conditional,
  ScrollSpyProps,
  Tooltip,
} from '@payaca/ambrosia';
import { FC, PropsWithChildren } from 'react';

import { getConnectionApplicationStatusBadgeColour } from '@/helpers/connectionApplications';
import EnaFormLayout from '@/ui/components/enaForms/EnaFormLayout';
import { useIsPayacaAdmin } from '@/utils/customHooks';

import { useHistory } from 'react-router';

export interface IProps {
  sections: ScrollSpyProps['sections'];
  submitProps?: ButtonProps;
  connectionApplication?: {
    status: string;
    connectionApplicationStatus?: string | null;
    commissioning?: { submittedAt?: string | null } | null;
  };
}

const ConnectionApplicationLayout: FC<PropsWithChildren<IProps>> = (props) => {
  const { sections, submitProps, connectionApplication, children } = props;

  const history = useHistory();

  const isPayacaAdmin = useIsPayacaAdmin();

  const header = (
    <>
      <h1>
        <Tooltip tooltipContent="Distribution Network Operator is a company responsible for operating, maintaining, and upgrading the electrical distribution network in a specific geographic region.">
          DNO
        </Tooltip>{' '}
        application
      </h1>

      <Conditional condition={!!submitProps}>
        <Button type="submit" className="ml-auto" size={'sm'} {...submitProps}>
          Submit
        </Button>
      </Conditional>

      <Conditional condition={!!connectionApplication?.commissioning}>
        <Button
          variant={
            connectionApplication?.commissioning?.submittedAt
              ? 'secondary'
              : undefined
          }
          className="ml-auto"
          onClick={() =>
            history.push(`${window.location.pathname}/commissioning`)
          }
        >
          {connectionApplication?.commissioning?.submittedAt
            ? 'View commissioning info'
            : 'Submit commissioning info'}
        </Button>
      </Conditional>
    </>
  );

  return (
    <EnaFormLayout sections={sections} header={header}>
      {children}
    </EnaFormLayout>
  );
};

export default ConnectionApplicationLayout;
